const resource = 'unknown_registrations'

export default $axios => ({
  addAlertToUknownRegistration(id, params) {
    return $axios.$patch(`/${resource}/${id}/alert`, params)
  },

  getServiceName: name => 'unknownRegistrationService',
})
